import './ModuleLoader.css'

export type ModuleLoaderProps = {
  label?: string
  variant?: 'page' | 'screen' | 'inline'
  tone?: 'light' | 'dark'
}

/**
 * Shared wait state for lazy modules, route gates, and page data fetches.
 */
export function ModuleLoader ({
  label = 'Loading',
  variant = 'page',
  tone = 'light',
}: ModuleLoaderProps) {
  return (
    <div
      className={`module-loader module-loader--${variant} module-loader--${tone}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="module-loader__spinner" aria-hidden="true">
        <span className="module-loader__ring" />
        <span className="module-loader__ring module-loader__ring--inner" />
        <span className="module-loader__core" />
      </div>
      <p className="module-loader__label">{label}</p>
    </div>
  )
}
